module.exports = __webpack_public_path__ + "img/金钱草.242e924f.jpg";